export function isArrayObject(data) {
  return (Object.prototype.toString.call(data) === '[object Array]')
    && (Object.prototype.toString.call(data[0]) === '[object Object]');
}

export function isObject(data) {
  return Object.prototype.toString.call(data) === '[object Object]';
}

export function isFunction(data) {
  return Object.prototype.toString.call(data) === '[object Function]';
}

export function isArray(data) {
  return Object.prototype.toString.call(data) === '[object Array]';
}

export function isString(data) {
  return Object.prototype.toString.call(data) === '[object String]';
}

export function isArrayBuffer(data) {
  return Object.prototype.toString.call(data) === '[object ArrayBuffer]';
}

export function isNumber(data) {
  return typeof data === 'number' && Number.isFinite(data);
}

export function mytypeof(data) {
  let t = typeof data;
  if (t === 'object' && isArray(data)) {
    t = 'array';
  }
  return t;
}

/**
 * 展开嵌套对象成数组
 */
export function flattenObject(obj, prefix) {
  const flattened = [];
  const keys = Object.keys(obj);
  for (let i = 0; i < keys.length; i += 1) {
    const k = keys[i];
    const v = obj[k];
    const newK = prefix ? `${prefix}.${k}` : k;
    if (mytypeof(v) === 'object') {
      flattened.push(...flattenObject(v, newK));
    } else if (mytypeof(v) !== 'array') {
      flattened.push({ k: newK, v });
    }
  }
  return flattened;
}

export function clone(val) {
  return (val instanceof Object) ? JSON.parse(JSON.stringify(val)) : val;
}

export function paramsToFormData(obj) {
  if (isObject(obj)) {
    const params = new URLSearchParams();
    Object.keys(obj).forEach((key) => {
      params.append(key, obj[key]);
    });

    return params;
  }
  return obj;
}

export const subdomain = window.location.hostname.split('.')[0];

//export const appTitle = '智能监控';
export const appTitle = '北斗监测云';


export function hexStringToUtf8(hexString) {
  const rawStr = hexString.trim().replace(/(0x|0X)/g, '');
  const len = rawStr.length;
  if (len % 2 !== 0) {
    throw new Error('输入内容不是合法的十六进制字符串');
  }
  const bytes = [];
  for (let i = 0; i < len; i += 2) {
    const byte = parseInt(rawStr.substr(i, 2), 16); // ASCII Code Value
    bytes.push(byte);
  }
  const uint8Array = new Uint8Array(bytes);
  return new TextDecoder('utf-8').decode(uint8Array);
}

export function formatHexString(hexString) {
  const rawStr = hexString.trim().replace(/(0x|0X)/g, '');
  const len = rawStr.length;
  if (len % 2 !== 0) {
    throw new Error('输入内容不是合法的十六进制字符串');
  }
  const bytes = [];
  for (let i = 0; i < len; i += 2) {
    const byte = rawStr.substr(i, 2).toUpperCase();
    bytes.push(byte);
  }
  return bytes.join(' ');
}

export function subUsers(rows, id) {
  if (!(rows && rows.length)) return [];
  if (typeof id !== 'number') return rows;
  const result = [];
  rows.forEach((item) => {
    if (item.parentId === id) {
      const children = subUsers(rows, item.id);
      if (children.length) item.children = children;
      result.push(item);
    }
  });
  return result;
}
